import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import HtmlToReact from 'html-to-react';
import { Link, Typography } from '@tkww/the-bash-frontend';

import { eventBlurbCtaClick } from 'state/modules/analytics/events';

const EventBlurb = (props) => {
  const { header, blurb, clickArea, title } = props;
  const dispatch = useDispatch();

  const onLinkCLick = (targetClickArea, clickDestination, titleTag) => {
    dispatch(eventBlurbCtaClick(targetClickArea, clickDestination, titleTag));
  };

  const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);

  const parser = new HtmlToReact.Parser();
  const processingInstructions = [
    {
      shouldProcessNode: (node) => node && node.name && node.name === 'a',
      processNode: (node, children) =>
        React.createElement(
          Link,
          {
            ...node.attribs,
            key: node.attribs.href,
            path: node.attribs.href,
            onClick: () => onLinkCLick(clickArea, node.attribs.href, title),
          },
          children
        ),
    },
    {
      // Anything else
      shouldProcessNode: () => true,
      processNode: processNodeDefinitions.processDefaultNode,
    },
  ];

  const blurbWithLinks = parser.parseWithInstructions(blurb, () => true, processingInstructions);

  if (!blurb || blurb === '') return <></>;

  return (
    <>
      {header && (
        <Typography variant="h2" align="center" fontSize={18}>
          {header}
        </Typography>
      )}
      <Typography variant="body1">{blurbWithLinks}</Typography>
    </>
  );
};

export default EventBlurb;

EventBlurb.defaultProps = {
  header: '',
  blurb: '',
};

EventBlurb.propTypes = {
  header: PropTypes.string,
  blurb: PropTypes.string,
  clickArea: PropTypes.string.isRequired,
};
